import PageHead from "../../../layout/PageHead";
import {
  ProjectOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import {
  SECTIONS,
} from "../../../../config/constants";
import { useEffect, useState } from "react";
import "./UnfinishedMappings.css";
import Datatable from "../../../shared/components/Datatable";
import { ColumnsType } from "antd/lib/table";
import {
  Button,
  DrawerProps,
} from "antd";
import MappingService from "../../../../services/mappings/MappingService";
import { useNavigate } from "react-router-dom";
import {ROUTES} from "../../../../config/consts/routes";

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.report.name,
  },
  {
    path: ROUTES.report.unfinishedMappings.route,
    breadcrumbName: ROUTES.report.unfinishedMappings.name,
  },
];

function UnfinishedMappings() {
  const { t, i18n } = useTranslation("translations");
  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [data, setData] = useState<DataType[]>([]);
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [placement, setPlacement] =
    useState<DrawerProps["placement"]>("bottom");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  const [components, setComponents] = useState<any>([]);
  const [fullComponents, setFullComponents] = useState<any>([]);
  const [componentKeys, setComponentKeys] = useState<any>([]);
  const [objects, setObjects] = useState<any>([]);

  const navigate = useNavigate();

  interface DataType {
    groupCode: any;
    entity: any;
    operation: any;
    toTable: any;
    toField: any;
    sourceTable: any;
  }

  useEffect(() => {
    document.title = ROUTES.report.unfinishedMappings.name;
  }, []);

  useEffect(() => {
    MappingService.getAllUnfinished().then((response:any) => {
        setData(response.data);
        setIsTableLoading(false);
    })
  }, [])

  const columns: ColumnsType<DataType> = [
    {
      title: "Group Code",
      dataIndex: "groupCode",
      key: "groupCode",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
      // ...getColumnSearchProps(
      //   "ruleName",
      //   onRuleNameFilterChange,
      //   ruleNameFilterTreeData,
      //   ruleNameCheckedKeys,
      //   onRuleNameTreeItemCheck,
      //   ruleNameAscending,
      //   ruleNameDescending,
      //   setRuleNameAscending,
      //   setRuleNameDescending
      // ),
      sorter: (a, b) => a.groupCode.localeCompare(b.groupCode),
    },
    {
      title: "Entity",
      dataIndex: "entity",
      key: "entity",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
      // ...getColumnSearchProps(
      //   "ruleName",
      //   onRuleNameFilterChange,
      //   ruleNameFilterTreeData,
      //   ruleNameCheckedKeys,
      //   onRuleNameTreeItemCheck,
      //   ruleNameAscending,
      //   ruleNameDescending,
      //   setRuleNameAscending,
      //   setRuleNameDescending
      // ),
      sorter: (a, b) => a.entity.localeCompare(b.entity),
    },
    {
      title: "Operation",
      dataIndex: "operation",
      key: "operation",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
      // ...getColumnSearchProps(
      //   "ruleName",
      //   onRuleNameFilterChange,
      //   ruleNameFilterTreeData,
      //   ruleNameCheckedKeys,
      //   onRuleNameTreeItemCheck,
      //   ruleNameAscending,
      //   ruleNameDescending,
      //   setRuleNameAscending,
      //   setRuleNameDescending
      // ),
      sorter: (a, b) => a.operation.localeCompare(b.operation),
    },
    {
      title: "To Table",
      dataIndex: "toTable",
      key: "toTable",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
      // ...getColumnSearchProps(
      //   "ruleName",
      //   onRuleNameFilterChange,
      //   ruleNameFilterTreeData,
      //   ruleNameCheckedKeys,
      //   onRuleNameTreeItemCheck,
      //   ruleNameAscending,
      //   ruleNameDescending,
      //   setRuleNameAscending,
      //   setRuleNameDescending
      // ),
      sorter: (a, b) => a.toTable.localeCompare(b.toTable),
    },
    {
      title: "Source Table",
      dataIndex: "sourceTable",
      key: "sourceTable",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
      // ...getColumnSearchProps(
      //   "ruleName",
      //   onRuleNameFilterChange,
      //   ruleNameFilterTreeData,
      //   ruleNameCheckedKeys,
      //   onRuleNameTreeItemCheck,
      //   ruleNameAscending,
      //   ruleNameDescending,
      //   setRuleNameAscending,
      //   setRuleNameDescending
      // ),
      sorter: (a, b) => a.sourceTable.localeCompare(b.sourceTable),
    },
    {
      title: "To Field",
      dataIndex: "toField",
      key: "toField",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
      // ...getColumnSearchProps(
      //   "ruleName",
      //   onRuleNameFilterChange,
      //   ruleNameFilterTreeData,
      //   ruleNameCheckedKeys,
      //   onRuleNameTreeItemCheck,
      //   ruleNameAscending,
      //   ruleNameDescending,
      //   setRuleNameAscending,
      //   setRuleNameDescending
      // ),
      sorter: (a, b) => a.toField.localeCompare(b.toField),
    },
  ];

  const scroll = { y: "calc(70vh - 10em)" };

  const onResolveClick = (record: any) => {
    if (record.operation.toLowerCase() === "legacy") {
      window.open(
        `${ROUTES.operation.legacyMapping.tabs.mapping.route}&groupCode=${record.groupCode}&entity=${record.entity}&sourceTable=${record.sourceTable}`
      );
    }

    if (record.operation.toLowerCase() === "validation") {
      window.open(
        `${ROUTES.operation.validationRules.tabs.validationMapping.route}&groupCode=${record.groupCode}&entity=${record.entity}`
      );
    }

    if (record.operation.toLowerCase() === "loadfile") {
      window.open(
        `${ROUTES.operation.loadFileSetup.route}?groupCode=${record.groupCode}&entity=${record.entity}&toTable=${record.toTable}`
      );
    }
  }

  const resolveActionItem = (record: any) => {
    return (
      <Button
          className={"update-button"}
          size="small"
          icon={<CheckOutlined />}
          onClick={() => onResolveClick(record)}
          >
          {t("General.Labels.Resolve", {
              lngs: i18n.languages,
              defaultValue: "Resolve",
          })}
      </Button>
    )
  }

  return (
    <div>
      <PageHead
        title={t(
          "Page.Reports.Headers.UnfinishedMappings",
          {
            lngs: i18n.languages,
            defaultValue: "Unfinished Mappings",
          }
        )}
        icon={<ProjectOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={true}
        setSelectEntityDisabled={true}
        setSelectOperationDisabled={true}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={false}
      />
      <div className="page-body">
        <Datatable
          scroll={scroll}
          tableColumns={columns}
          data={data}
          setData={setData}
          isTableLoading={isTableLoading}
          otherActions={[]}
          otherRowEnabled={false}
          editRowEnabled={false}
          copyRowEnabled={false}
          deleteRowEnabled={false}
          onEditFunc={undefined}
          onCopyFunc={undefined}
          onDeleteFunc={undefined}
          onDoubleClickRow={undefined}
          selectable={false}
          multiSelect={false}
          selectedRows={[]}
          setSelectedRows={undefined}
          onCustomActionItem={resolveActionItem}
        ></Datatable> 
      </div>
    </div>
  );
}

export default UnfinishedMappings;
